import * as React from "react";
import * as main from "../../../styles/main.module.scss";
import * as screen5 from "./screen5.module.scss";

export const Tasks = ({ targetGroup }) => {
  return (
    <section className={screen5.courseTasks}>
      <div className="container">
        <h2 className={main.title2}>Какие задачи решает курс:</h2>
        <div className={screen5.tasks__block}>
          <div className={screen5.task__item}>
            <div className={screen5.task__itemTitle}>Скорость и качество обучения:</div>
            <div className={screen5.task__itemText}>ребёнок получает инструменты, с которыми он сможет тратить меньше времени
              на обучение при лучших результатах. Полученные знания остаются в памяти надолго: схема «сдал — забыл»
              уступает место формуле «выучил раз и навсегда».
            </div>
          </div>
          <div className={screen5.task__item}>
            <div className={screen5.task__itemTitle}>Память и внимание:</div>
            <div className={screen5.task__itemText}>эффективное обучение невозможно, если эти психические процессы слабо
              натренированы. Упражнения на развитие памяти и внимания красной нитью проходят через весь курс, в 2-4 раза
              улучшая показатели к концу обучения. Развитые память и внимание важны не только для обучения, но и в
              повседневной жизни. Ребёнок становится более собранным, легче концентрируется на том, что важно в данный
              момент, может работать над заданиями не отвлекаясь,хорошо запоминает детали и факты.
            </div>
          </div>
          <div className={screen5.task__item}>
            <div className={screen5.task__itemTitle}>Эффективное чтение:</div>
            <div className={screen5.task__itemText}>качество чтения во многом определяет успешность ребёнка в обучении. Если
              ребёнок читает медленно, плохо понимает прочитанное, ему с трудом даются не только гуманитарные предметы,
              но и точные науки. Ребёнку сложно понять условие текстовой задачи, вникнуть в суть вопроса. В программу
              курса заложено развитие навыков чтения (скорость и понимание) — успеваемость ребёнка и скорость выполнения
              заданий возрастает.
            </div>
          </div>
          <div className={screen5.task__item}>
            <div className={screen5.task__itemTitle}>Уверенность в собственных силах:</div>
            <div className={screen5.task__itemText}>благодаря новым технологиям обучения, у ребёнка начинает получаться то, что
              раньше давалось с трудом. Чувство «Я могу» расширяет горизонты возможностей и повышает самооценку.
            </div>
          </div>
          <div className={screen5.task__item}>
            <div className={screen5.task__itemTitle}>Мотивация:</div>
            <div className={screen5.task__itemText}>по мере освоения навыков, учёба даётся ребёнку всё легче. Ребёнку нравится
              чувствовать себя успешным, ему хочется делать это ещё и ещё — ребёнок начинает учиться с удовольствием.
            </div>
          </div>
          <div className={screen5.task__item}>
            <div className={screen5.task__itemTitle}>Самостоятельность:</div>
            <div className={screen5.task__itemText}>обладая множеством инструментов для всех видов учебной деятельности,
              ребёнок сам выбирает нужные способы и методы для разных задач. Он в состоянии самостоятельно готовиться к
              контрольным, тестам и экзаменам.
            </div>
          </div>
          <div className={screen5.task__item}>
            <div className={screen5.task__itemTitle}>Стремление к самообразованию:</div>
            <div className={screen5.task__itemText}>действенность курса распространяется далеко за
              {
                targetGroup === "teens" ?
                  " пределы 8-11 классов и даже за "
                  :
                  targetGroup === "kids" ?
                    " пределы 5-7 классов и даже за "
                    :
                    " "
              }
              окончание школы. Полученные технологии позволят ребёнку повышать интеллектуальный и профессиональный
              уровень на протяжении всей жизни. Эффективные подходы становятся способом обучения и мышления, образом
              жизни.
            </div>
          </div>
          <div className={screen5.task__item}>
            <div className={screen5.task__itemTitle}>Умение планировать<br/>и достигать целей:</div>
            <div className={screen5.task__itemText}>занимаясь с курсом, ребёнок привыкает к структурированной систематической
              интеллектуальной работе. Он учится разделять большие задачи на подзадачи и достигать желаемого результата.
              В дальнейшем он сможет переложить эти принципы к любым жизненным задачам
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
